import Icon from '@/components/ui/AppIcon';

interface TimelineStep {
  title: string;
  description: string;
  duration: string;
}

interface TimelinePreviewProps {
  steps: TimelineStep[];
}

export default function TimelinePreview({ steps }: TimelinePreviewProps) {
  return (
    <div className="space-y-6">
      {steps.map((step, index) => (
        <div key={index} className="flex items-start space-x-4">
          <div className="flex-shrink-0 w-10 h-10 rounded-full bg-primary text-primary-foreground flex items-center justify-center font-heading font-bold">
            {index + 1}
          </div>
          <div className="flex-1">
            <div className="flex items-center justify-between mb-2">
              <h4 className="font-heading font-semibold text-base text-text-primary">
                {step.title}
              </h4>
              <span className="text-sm text-text-secondary flex items-center">
                <Icon name="ClockIcon" size={16} className="mr-1" />
                {step.duration}
              </span>
            </div>
            <p className="text-sm text-text-secondary">{step.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
}